/*
 * @Author: liuhang liuhang@nextmar.com
 * @Date: 2025-07-23 17:00:00
 * @Description: Custom hook for processing image source with CDN, internationalization, and format validation
 */
import { resolveImageSrc } from '@/utils/image-src';
import { useLocale } from 'next-intl';
import type { StaticImport } from 'next/dist/shared/lib/get-img-props';

export const useImageSrc = (src: string | StaticImport) => {
  const locale = useLocale();
  return resolveImageSrc(src, locale);
};
